import React from 'react'
import ImagePathTest from '../components/test/ImagePathTest'

const ImagePathTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ImagePathTest />
    </div>
  )
}

export default ImagePathTestPage